<template>
  <div id="cardGrafExtratoPrevisao" style="height: 380px; overflow: hidden;">
    <q-card-section>
      <div class="row items-center no-wrap">
        <div class="col">
          <div class="text-grey-9" style="font-size: 16px;">
            Fluxo de Caixa Diário
          </div>
        </div>
        <div class="col-auto">
          <q-btn color="grey-7" round flat icon="more_vert">
            <q-menu cover auto-close>
              <q-list>
                <q-item clickable @click="atualizarDados">
                  <q-item-section avatar><q-icon name="refresh" /></q-item-section>
                  <q-item-section>Atualizar</q-item-section>
                </q-item>
                <q-item clickable @click="removerCard">
                  <q-item-section avatar><q-icon name="delete" /></q-item-section>
                  <q-item-section>Remover</q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
        </div>
      </div>
    </q-card-section>

    <q-card-section>
      <div v-if="loading" class="text-center q-pa-md text-grey" style="padding-top: 50px">
          <q-spinner color="primary" size="3em" />
          <div class="q-mt-sm">Calculando previsões...</div>
      </div>

      <div v-else-if="error" class="text-center text-negative q-pa-md" style="padding-top: 50px">
          <q-icon name="warning" size="2em" />
          <div>Não foi possível carregar os dados.</div>
          <q-btn flat size="sm" label="Tentar novamente" @click="atualizarDados" />
      </div>

      <div v-else ref="chartContainer">
         <div v-if="series.length > 0">
             <apexchart
                v-if="ready"
                ref="chart"
                type="line"
                height="270"
                :options="chartOptions"
                :series="series"
             ></apexchart>
         </div>
         <div v-else class="text-center text-grey q-pa-md" style="padding-top: 50px">
            Sem movimentações para este período.
         </div>
      </div>
    </q-card-section>
  </div>
</template>

<script>
import axios from "@/axios-auth";
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "card-graf-extrato-previsao",
  components: {
    apexchart: VueApexCharts,
  },
  props: ['id', 'referencia'],

  data() {
    return {
      loading: false,
      error: false,
      ready: false,
      series: [],
      chartOptions: Object.freeze({
        chart: {
            // Vue 3 has no `_uid` (it read undefined, so every chart got the same id); `$.uid`
            // is the per-instance counter it replaced.
            id: 'apex-extrato-previsao-' + this.$.uid,
            type: 'line',
            stacked: false,
            toolbar: { show: true },
            animations: { enabled: false },
            redrawOnParentResize: false,
            redrawOnWindowResize: false,
        },
        grid: {
            padding: {
                bottom: 10
            }
        },
        stroke: { width: [3, 3, 0, 0, 0, 0], curve: 'smooth' },
        plotOptions: { bar: { columnWidth: '60%', borderRadius: 2 } },
        colors: ['#1976D2', '#90CAF9', '#388E3C', '#81C784', '#D32F2F', '#E57373'],
        dataLabels: { enabled: false },
        xaxis: {
            categories: [],
            title: { text: 'Dia do Mês' },
            labels: { style: { fontSize: '12px' } }
        },
        yaxis: {
            labels: {
                formatter: (value) => {
                    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                }
            }
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: (y) => {
                    if (typeof y !== "undefined") {
                        return y.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                    }
                    return y;
                }
            }
        },
        legend: { position: 'top', horizontalAlign: 'left' }
      })
    };
  },

  methods: {
    removerCard() {
      this.$store.dispatch("trocaVisibilidadeCard", { cardId: "20" });
    },

    atualizarDados() {
        if (!this.referencia) return;

        this.loading = true;
        this.error = false;

        axios.get(`/financeiro/extrato-previsao?referencia=${this.referencia}`)
            .then(res => {
                if (res.data && res.data.success) {
                    this.processarDados(res.data.data);
                } else {
                    this.series = [];
                }
            })
            .catch(() => {
                this.error = true;
            })
            .finally(() => {
                this.loading = false;
                this.$nextTick(() => this.waitForContainerWidth());
            });
    },

    processarDados(data) {
        this.series = Object.freeze(data.series || []);

        this.$nextTick(() => {
            if (this.$refs.chart && this.$refs.chart.updateOptions) {
                this.$refs.chart.updateOptions(
                    { xaxis: { categories: data.categories || [] } },
                    false, false, false
                );
            } else {
                this.chartOptions = Object.freeze({
                    ...this.chartOptions,
                    xaxis: {
                        ...this.chartOptions.xaxis,
                        categories: data.categories || []
                    }
                });
            }
        });
    },

    waitForContainerWidth() {
        const el = this.$refs.chartContainer;
        if (!el) return;

        if (el.offsetWidth > 0) {
            this.ready = true;
            return;
        }

        if (typeof ResizeObserver !== 'undefined') {
            this._resizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    if (entry.contentRect.width > 0) {
                        this.ready = true;
                        this._resizeObserver.disconnect();
                        this._resizeObserver = null;
                        break;
                    }
                }
            });
            this._resizeObserver.observe(el);
        } else {
            this.ready = true;
        }
    },
  },

  mounted() {
      this.atualizarDados();
  },

  beforeUnmount() {
      if (this._resizeObserver) {
          this._resizeObserver.disconnect();
          this._resizeObserver = null;
      }
  },

  watch: {
      referencia() {
          this.atualizarDados();
      }
  }
};
</script>
